import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Modal,
  ModalBody,
} from "reactstrap";
import Table from "../../components/react-table/Table";
import { GET, POST } from "../../helper/api";
import { COMPANY_CODE, renderPageStyle } from "../../utils/Utils";
import { getConfig } from "../../config";
import UpsertPITFeeComponent from "../pn/Components/UpsertPITFeeComponent";
import { colTableCn, colTableNvvp } from "./components/SalaryPerMonthColTable";

const { company } = getConfig();


const SalaryPerMonth = () => {
  const printRef = useRef();

  const [dataNvvp, setDataNvvp] = useState([]);
  const [summaryNvvp, setSummaryNvvp] = useState({});

  const [dataCn, setDataCn] = useState([]);
  const [summaryCn, setSummaryCn] = useState({});

  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [allowConfirmMonthYear, setAllowConfirmMonthYear] = useState(false);
  const [pitFee, setPitFee] = useState(null);
  const [updatedAt, setUpdatedAt] = useState();
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  const [view, setView] = useState({
    confirm: false,
    pitFee: false,
  });

  const onFormCancel = () => {
    setView({
      confirm: false,
      pitFee: false,
    });
    setPitFee(null);
  };


  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const confirmSalary = () => {
    POST(
      `/employee/keepingtime/confirm-salary-per-month`,
      { monthYear: filter.monthYear },
      {},
      true
    )
      .then(() => {
        toast.success('Xác nhận lương tháng thành công')
        setAllowConfirmMonthYear(false);
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        toggle('confirm');
      });
  }

  useEffect(() => {

    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const { monthYear } = filter;

    GET(
      `/employee/keepingtime/check-salary-per-month`,
      { monthYear },
      true
    ).then(({ data }) => {
      setAllowConfirmMonthYear(!data);
    }).catch(() => {
    });

    GET(
      "employee/keepingtime/salary-per-month",
      {
        monthYear,
      },
      true
    ).then((resp) => {
      const { data: { nvvp, cn } } = resp;
      setDataNvvp(nvvp.rows);
      setSummaryNvvp(nvvp.summary);

      setDataCn(cn.rows);
      setSummaryCn(cn.summary);
    });
  }, [filter, updatedAt]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/employee/keepingtime/salary-per-month-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Thời gian biểu"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Lương tháng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                      >
                        <ReactToPrint
                          trigger={() => <Button className={`btn btn-secondary`}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="btn-secondary ml-3">
                          Xuất excel
                        </Button>
                        {allowConfirmMonthYear ? <Button onClick={() => {
                          toggle("confirm")
                        }} className="btn-secondary ml-3">
                          Xác nhận tháng này
                        </Button>
                          : <></>}
                      </div>

                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <style>{renderPageStyle({
                    fontSize: 7,
                  })}</style>
                  <h5 className="text-center mt-2 mb-2">Báo cáo lương Nhân viên văn phòng {filter?.monthYear} công ty</h5>
                  <Table
                    loading={loading}
                    columns={colTableNvvp({
                      onDoubleClickPit: (item) => {
                        setView({
                          ...view,
                          pitFee: true,
                        })
                        setPitFee({
                          user: item.user,
                          amount: item?.pit || 0
                        });
                      }
                    })}
                    data={dataNvvp}
                    notShowPagi
                    isRotate

                    customRow={() => <tr className="font-weight-bold">
                      <td ><span>Tổng cộng</span></td>
                      {[...new Array(9)].map(() => <td className=" text-right">
                        <span>|</span>
                      </td>)}

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.productivitySalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.anotherBonus || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryNvvp.insuranceLeaveFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.grossSalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryNvvp.insuranceFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.taxableIncome || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.dependents || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.pitDeduction || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.assessableIncome || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryNvvp.pit || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      {company === COMPANY_CODE.CT && <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryNvvp.unionFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>}
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryNvvp.anotherFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryNvvp.finalSalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                    </tr>}
                  ></Table>
                  <h5 className="text-center mt-2 mb-2">Báo cáo lương Công nhân {filter?.monthYear} công ty</h5>
                  <Table
                    loading={loading}
                    columns={colTableCn({
                      onDoubleClickPit: (item) => {
                        setView({
                          ...view,
                          pitFee: true,
                        })
                        setPitFee({
                          user: item.user,
                          amount: item?.pit || 0
                        });
                      }
                    })}
                    data={dataCn}
                    notShowPagi
                    isRotate
                    customRow={() => <tr className="font-weight-bold">
                      <td><span>Tổng cộng</span></td>
                      <td className=" text-right"><span>|</span></td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.workingDay || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className=" text-right"><span>|</span></td>
                      <td className=" text-right"><span>|</span></td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.extraAndBonusHour || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      {[...new Array(17)].map((_, i) => <td key={i} className=" text-right"><span>|</span></td>)}
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.productivitySalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.extraAndBonusSalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.extraHourFoodAllowance || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.anotherBonus || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryCn.insuranceLeaveFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.grossSalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryCn.insuranceFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.taxableIncome || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.dependents || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.pitDeduction || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.assessableIncome || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryCn.pit || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                      {company === COMPANY_CODE.CT && <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryCn.unionFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>}
                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={(summaryCn.anotherFee || 0) * -1}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>

                      <td className=" text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summaryCn.finalSalary || 0}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                        />
                      </td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
      <Modal isOpen={view.confirm} toggle={() => toggle('confirm')}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-check bg-success"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn xác nhận tháng này không?{" "}
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => toggle('confirm')}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={(ev) => {
                  ev.preventDefault();
                  confirmSalary();
                }}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {
        view.pitFee && pitFee && <UpsertPITFeeComponent
          onCancel={() => onFormCancel()}
          onSuccess={() => {
            onFormCancel();
            setUpdatedAt(moment().valueOf());
          }}
          data={{
            ...pitFee,
            date: moment(filter.monthYear, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
          }}
        />
      }
    </React.Fragment>
  );
};

export default SalaryPerMonth;
